/**
 * The account picture, from Sam's "account pic icon generic" pair (Sept 19).
 *
 * Copied in by hand rather than run through `scripts/build-icons.mjs`, which
 * flattens multi-colour art to one fill, and rather than inlined raw, whose
 * `.cls-*` styles are global and would collide with any other inlined art. The
 * two files share the same four paths and differ only in their fills, so one
 * component draws both: selected, it sits on the highlight's parchment circle
 * and inverts.
 */

interface Props {
  size: number;
  selected?: boolean;
}

/** The ring around the unselected mark. */
const RING = '#625f5c';
const DARK = '#332826';
const LIGHT = '#f3ede5';
/** The selected art's parchment, which matches the highlight it sits on. */
const ON_LIGHT = '#f3eee7';

const DISC =
  'M66,33c0,7.93-2.79,15.19-7.44,20.88-2.2-8.4-8.43-15.19-16.51-18.13,3.71-2.81,5.9-7.18,5.9-11.89,0-8.25-6.71-14.95-14.95-14.95s-14.95,6.7-14.95,14.95c0,4.71,2.19,9.08,5.89,11.89-8.07,2.95-14.3,9.72-16.5,18.13C2.79,48.19,0,40.93,0,33,0,14.78,14.78,0,33,0s33,14.78,33,33Z';
const BODY =
  'M42.05,35.75c3.71-2.81,5.9-7.18,5.9-11.89,0-8.25-6.71-14.95-14.95-14.95s-14.95,6.7-14.95,14.95c0,4.71,2.19,9.08,5.89,11.89-8.07,2.95-14.3,9.72-16.5,18.13,6.05,7.39,15.25,12.12,25.56,12.12s19.5-4.73,25.56-12.12c-2.2-8.4-8.43-15.19-16.51-18.13ZM21.05,23.86c0-6.59,5.36-11.95,11.95-11.95s11.95,5.36,11.95,11.95c0,4.09-2.05,7.84-5.5,10.05-.32.21-.65.4-.98.57-.61.32-1.24.58-1.9.78h-.01c-.99.31-2.02.49-3.07.52-.16.02-.33.02-.49.02-.18,0-.35,0-.53-.02h-.01c-.97-.03-1.92-.19-2.83-.46-.69-.2-1.35-.46-1.99-.79-.38-.18-.74-.39-1.1-.62-3.44-2.21-5.49-5.97-5.49-10.05ZM33,63c-8.52,0-16.53-3.57-22.22-9.84,2.43-7.27,8.36-12.99,15.78-15.11.34-.1.65-.2.95-.3,1.73.69,3.59,1.05,5.49,1.05s3.79-.36,5.53-1.07c.25.1.52.2.8.29l.06.02h.05c7.42,2.13,13.35,7.85,15.77,15.13-5.69,6.26-13.7,9.83-22.21,9.83Z';
const SHOULDERS =
  'M55.21,53.17c-5.69,6.26-13.7,9.83-22.21,9.83s-16.53-3.57-22.22-9.84c2.43-7.27,8.36-12.99,15.78-15.11.34-.1.65-.2.95-.3,1.73.69,3.59,1.05,5.49,1.05s3.79-.36,5.53-1.07c.25.1.52.2.8.29l.06.02h.05c7.42,2.13,13.35,7.85,15.77,15.13Z';
const HEAD =
  'M44.95,23.86c0,4.09-2.05,7.84-5.5,10.05-.32.21-.65.4-.98.57-.61.32-1.24.58-1.9.78h-.01c-.99.31-2.02.49-3.07.52-.16.02-.33.02-.49.02-.18,0-.35,0-.53-.02h-.01c-.97-.03-1.92-.19-2.83-.46-.69-.2-1.35-.46-1.99-.79-.38-.18-.74-.39-1.1-.62-3.44-2.21-5.49-5.97-5.49-10.05,0-6.59,5.36-11.95,11.95-11.95s11.95,5.36,11.95,11.95Z';

export default function AccountIcon({ size, selected = false }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 66 66" aria-hidden="true" focusable="false">
      <path fill={selected ? ON_LIGHT : RING} d={DISC} />
      <path fill={selected ? ON_LIGHT : DARK} d={BODY} />
      <path fill={selected ? DARK : LIGHT} d={SHOULDERS} />
      <path fill={selected ? DARK : LIGHT} d={HEAD} />
    </svg>
  );
}
